import { Box, Drawer } from '@mui/material';
import { useState } from 'react';
import ResizablePanel from '../../components/Resizeable/ResizablePanel';
import { Provider as LpkProvider } from './context';
import { ActionProviders } from './actions/ActionProviders';
import { ActionDialogs } from './actions/ActionDialogs';
import LpkMap from './LpkMap';
import { LpkTabs } from './Tabs';
import { Section } from '../Section';

export default function Lpk() {
  const [sidePanel, setSidePanel] = useState();

  return (
    <LpkProvider>
      <ActionProviders>
        <ActionDialogs>
          <Section>
            <Box sx={{ height: '100%', display: 'flex', flexDirection: 'row' }}>
              <Box
                sx={{
                  position: 'relative',
                  display: 'flex',
                  height: '100%',
                  flex: 1,
                  overflow: 'hidden',
                  flexDirection: 'column',
                }}
              >
                <ResizablePanel
                  topPanel={<LpkMap />}
                  bottomPanel={<LpkTabs renderSidePanel={setSidePanel} />}
                />
              </Box>
              {buildSidePanel()}
            </Box>
          </Section>
        </ActionDialogs>
      </ActionProviders>
    </LpkProvider>
  );

  function buildSidePanel() {
    if (!sidePanel) return null;

    return (
      <Drawer
        open={Boolean(sidePanel)}
        anchor="right"
        hideBackdrop
        variant="persistent"
        sx={{
          flexShrink: 0,
          '& .MuiDrawer-paper': { border: 'none', position: 'static' },
        }}
      >
        {sidePanel}
      </Drawer>
    );
  }
}
